import { render } from "./IconGetApp.vue?vue&type=template&id=7bfab3be"
import script from "./IconGetApp.vue?vue&type=script&lang=js"
export * from "./IconGetApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__